// extracted by mini-css-extract-plugin
export default {"outer":"Guidelines_outer__ororO","guidelines":"Guidelines_guidelines__0+duA","svg":"Guidelines_svg__h+TWc","text":"Guidelines_text__n6w-n"};